import React, {useState, useEffect} from 'react';
import PropTypes from 'prop-types';
import styled from '@emotion/styled';
import {Grid, Box} from '@mui/material';

import {theme} from '../../../themes/default-theme';
import SeriesCard from '../NewMainNav/SeriesCard';
import Text from '../../typography';

const Container = styled.div`  
  padding: 120px 0;

  h3 {
    font-weight:800;
    ${theme.breakpoints.up('md')} {

    }
  }
    
  ${props => props.background == 'light' && `
    background-color: white;
  `}

  ${props => props.background == 'dark' && `
    background-color: black; //${theme.palette.shadeBlack};

    h3,
    * {
      color: white;
    }
  `}
`

const RecentlyViewedContainer = styled.div`
  display: flex;
  justify-content: center;

  ${theme.breakpoints.down("sm")} {
    flex-direction: column;
  }
`
const Heading = styled(props => {
  return <Text {...props} />
})`
  margin-bottom: 20px;
  ${theme.breakpoints.up("md")} {
    text-align: center;
    margin-bottom: 30px; 
  }
  ${theme.breakpoints.up("lg")} {
    margin-bottom: 50px;
  }
`


export const RecentlyViewed = props => {
  const {
    series,
    background
  } = props;
  console.log('sss',series)
  return (
    <Container background={background}>
      <Grid container spacing={0} direction={'row'} wrap="nowrap" justifyContent={'space-between'} align={'flex-start'} >
        <Grid size={12}>
          <Box px={2}>
            <Heading variant="h3" size="extraLarge" colour="charcoal" uppercase={true}>RECENTLY VIEWED MODELS</Heading>
          </Box >
        </Grid>
      </Grid>
      <Grid container className="hasPadding" direction={'row'} wrap="nowrap" justifyContent={'space-between'} align={'flex-start'} >
        <Grid
          size={{
            xs: 12,
            md: 12
          }}>
          <Box px={2}>
            <RecentlyViewedContainer>
              {series && series.length > 0 && series.map((item, index) => {
                console.log('series card item refactor', item);
                // refactor here to integrate with new schema as well as old structure
                const obj = (item && item.seriesDetails) ? {
                  ...item,
                  // sleeps: item.seriesDetails.sleepsMax,
                  subTitle: item.spec ? item.spec : ''
                } : item
                return (
                  <SeriesCard
                    hideSleeps={true}
                    key={index}
                    {...obj}
                  />
                )
              })}
            </RecentlyViewedContainer>
          </Box>
        </Grid>
      </Grid>
    </Container>
  );
}

RecentlyViewed.propTypes = {
  series: PropTypes.array.isRequired,
  background: PropTypes.string
}

RecentlyViewed.defaultProps = {
  series: [],
  background: null
}

export default RecentlyViewed;